import { render, staticRenderFns } from "./TabelaPaginacaoFixa.vue?vue&type=template&id=e5ae530c&scoped=true&"
import script from "./TabelaPaginacaoFixa.vue?vue&type=script&lang=js&"
export * from "./TabelaPaginacaoFixa.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPaginacaoFixa.vue?vue&type=style&index=0&id=e5ae530c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5ae530c",
  null
  
)

export default component.exports